import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import type { ChildMonitoredItem } from './types';

const selectChildItemsState = (state: RootState) => state.childItems;

export const selectChildItems = createSelector(
  [selectChildItemsState],
  (s): ChildMonitoredItem[] => s?.items ?? [],
);

export const selectChildItemsLoaded = createSelector(
  [selectChildItemsState],
  (s): boolean => s?.hasLoaded ?? false,
);

// Convenience: monitored items for a single child, keyed by their userId.
// The API's outer object uses `id` as the child's userId (see
// `services/child-items/types.ts`), so we match on `id`.
export const makeSelectChildItemsForUser = (userId: string) =>
  createSelector([selectChildItems], (items) =>
    items.find((i) => i.id === userId),
  );
